export default __webpack_public_path__ + "locales/ja-JP/InviteDialog.json?hash=da1178ca75a64574e0ec419328d144c4";